module.exports = __webpack_public_path__ + "img/page.0129e70e.png";